export default __webpack_public_path__ + "static/media/hmd_background_xl2.42490b15.jpg";